/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Validation_Amountrequired3Inputs */

const en_coinvestments_indicateinterest_validation_amountrequired3 = /** @type {(inputs: Coinvestments_Indicateinterest_Validation_Amountrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter an investment amount`)
};

/**
* | output |
* | --- |
* | "Please enter an investment amount" |
*
* @param {Coinvestments_Indicateinterest_Validation_Amountrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_validation_amountrequired3 = /** @type {((inputs?: Coinvestments_Indicateinterest_Validation_Amountrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Validation_Amountrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_validation_amountrequired3(inputs)
});
export { coinvestments_indicateinterest_validation_amountrequired3 as "coInvestments_indicateInterest_validation_amountRequired" }